import makeStyles from "@mui/styles/makeStyles";
import { Bold, ExtraBold, Regular, SemiBold } from "../../utils";
export const useStyles = makeStyles((theme, props) => ({
    root: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "16px",
        height: `calc(100vh - 147px)`,
        overflow: "hidden",
        margin: "14px"
    },
    content: {
        textAlign: "center"
    },
    button: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        fontSize:"0.875rem"
    },
    filterButton: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px",
        height: '40px',
        width: '40px'
    },
    viewDialog: {
        "& .MuiPaper-root": {
            maxWidth: "1000px !important",
        },
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
        },
    },
    acceptConfirmDialog: {
        "& .MuiPaper-root": {
            maxWidth: "100%",
            width: "100%",
        },
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
            margin: "60px"
        },
    },
    unitViewDialog: {
        "& .MuiPaper-root": {
            maxWidth: "900px !important",
        },
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
        },
    },
    viewDialogHeader: {
        padding: "16px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #E4E8EE"
    },
    viewDialogHeaderContainer: {
        display: "flex",
        columnGap: "12px"
    },
    statusTag: {
        borderRadius: "4px",
        backgroundColor: "#FFF4EB",
        padding: "3px 6px"
    },
    statusTagText: {
        fontSize:"0.75rem",
        fontFamily: Bold,
        color: "#FF9340"
    },
    viewDialogHeaderTitle: {
        fontFamily: ExtraBold,
        fontSize:"1rem",
        color: "#091B29"
    },
    viewDialogCloseButton: {
        padding: "0px"
    },
    viewDialogBody: {
        padding: "16px",
        overflowY: "overlay"
    },
    acceptDialogBody: {
        width: "100%",
    },
    viewDialogText1: {
        display: "flex",
        fontFamily: SemiBold,
        fontSize:"0.75rem",
        color: "#98A0AC",
        wordBreak: "break-all",
    },
    viewDialogText2: {
        display: "flex",
        fontFamily: SemiBold,
        fontSize:"0.875rem",
        color: "#091B29",
        wordBreak: "break-all"
    },
    viewDialogText3: {
        fontFamily: Bold,
        fontSize:"0.75rem",
        color: "#091B29"
    },
    viewDialogText4: {
        fontFamily: Bold,
        fontSize:"0.875rem",
        color: "#091B29"
    },
    viewDialogText5: {
        fontFamily: Regular,
        fontSize:"0.75rem",
        color: "#4E5A6B",
        direction: "ltr"
    },
    viewDialogText5No: {
        fontFamily: Regular,
        fontSize:"0.75rem",
        color: "#4E5A6B",
        direction: 'ltr'
    },
    viewDialogTextNo: {
        fontFamily: Regular,
        fontSize:"0.75rem",
        color: "#4E5A6B",
        direction: 'ltr'
    },
    viewDialogText6: {
        fontFamily: Bold,
        fontSize:"0.875rem",
        color: "#4E5A6B"
    },
    viewDialogText7: {
        fontFamily: Regular,
        fontSize:"0.75rem",
        color: "#98A0AC",
        marginInline: "6px"
    },
    viewDialogText8: {
        fontFamily: Bold,
        fontSize:"1rem",
        color: "#091B29"
    },
    clickableText: {
        marginTop: "16px",
        color: "#5078E1",
        fontSize:"0.75rem",
        fontFamily: SemiBold,
        cursor: "pointer"
    },
    tableHeaderText: {
        padding: "12px",
        fontFamily: Bold,
        fontSize:"0.75rem",
        color: "#98A0AC",
        wordBreak: "break-all"
    },
    tableDescriptionText: {
        padding: "12px",
        fontFamily: SemiBold,
        fontSize:"0.875rem",
        color: "#4E5A6B",
        wordBreak: "break-all"
    },
    priceDescriptionText: {
        fontFamily: SemiBold,
        fontSize:"0.875rem",
        color: "#4E5A6B",
        wordBreak: "break-all"
    },
    tableQtyText: {
        padding: "12px",
        fontFamily: Regular,
        fontSize:"0.875rem",
        color: "#4E5A6B",
        wordBreak: "break-all"
    },
    tableTotalText: {
        padding: "12px",
        fontFamily: Bold,
        fontSize:"0.875rem",
        color: "#091B29",
        wordBreak: "break-all"
    },
    priceTotalText: {
        fontFamily: Bold,
        fontSize:"0.875rem",
        color: "#091B29",
        wordBreak: "break-all"
    },
    viewDialogContactContainer: {
        padding: "14px 12px",
        backgroundColor: "#F5F7FA",
        borderRadius: "4px",
        border: "1px solid #E4E8EE"
    },
    viewDialogContactDivider: {
        backgroundColor: "#E4E8EE",
        height: "1px"
    },
    tableDivider: {
        backgroundColor: "#E4E8EE",
        height: "1px"
    },
    viewDialogContactCard: {
        width: "100%",
        display: "flex",
        padding: "10px 12px",
        backgroundColor: "white",
        border: "1px solid #E4E8EE",
        borderRadius: "4px",
        // boxShadow: "0px 8px 24px #0717411F"

    },
    period: {
        height: "6px",
        width: "6px",
        margin: "0px 8px",
        borderRadius: "50%",
        backgroundColor: "#CED3DD"
    },
    viewDialogTableContainer_1: {
        marginBottom: "8px",
        padding: "16px 16px 0px 16px",
        backgroundColor: "rgba(242, 244, 247, 0.5)",
        borderRadius: "4px",
    },
    viewDialogTableContainer_2: {
        padding: "16px 16px 0px 16px",
        backgroundColor: "rgba(242, 244, 247, 0.5)",
        borderRadius: "4px",
    },
    agreementSummary: {
        marginBottom: "8px",
        backgroundColor: "rgba(242, 244, 247, 0.5)",
        borderRadius: "4px",
    },
    viewDialogTable: {
        width: "100%"
    },
    contactAvatar: {
        borderRadius: "4px",
        boxShadow: "0px 3px 16px rgba(0, 0, 0, 0.12)",
        marginInlineEnd: "12px"
    },
    viewDialogButtonContainer: {
        display: "flex",
        columnGap: "8px",
    },
    acceptButton: {
        borderRadius: theme.palette.borderRadius,
        height: "40px",
        boxShadow: "none",
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "white",
        backgroundColor: "#5AC782",
        "&:hover": {
            backgroundColor: "#5AC782 ",
        },
    },
    declineButton: {
        borderRadius: theme.palette.borderRadius,
        height: "40px",
        boxShadow: "none",
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "white",
        backgroundColor: "#FF4B4B",
        "&:hover": {
            backgroundColor: "#FF4B4B ",
        },
    },
    acceptDeclineDialog: {
        "& .MuiDialog-paper": {
            borderRadius: theme.palette.borderRadius,
            padding: "0px",
            width: "475px"
        },
    },
    acceptDeclineDialogBody: {
        padding: "24px",
        overflowY: "overlay"
    },
    acceptDeclineDialogFooter: {
        display: "flex",
        columnGap: "12px",
        padding: "24px",
    },
    acceptDeclineButton: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        boxShadow: "none",
        border: "1px solid #5078E1",
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "white",
        backgroundColor: "#5078E1",
        "&:hover": {
            backgroundColor: "#5078E1 ",
        },
    },
    cancelButton: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        boxShadow: "none",
        border: "1px solid #5078E1",
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "#5078E1",
        backgroundColor: "white",
        "&:hover": {
            backgroundColor: "#E4E8EE ",
        },
    },
    occupiedErrorCard: {
        display: "flex",
        backgroundColor: "#FF4B4B14",
        padding: "8px 16px",
        borderRadius: "4px",
        justifyContent: "space-between"
    },
    occupiedErrorTextDiv: {
        display: "flex"
    },
    occupiedErrorText: {
        fontSize:"0.875rem",
        color: "#FF4B4B",
        fontFamily: Bold,
        marginRight: "8px"
    },
    occupiedErrorIconDiv: {
        display: "flex",
        alignItems: "center",
        transform: "rotate(180deg)"
    },
    tableBody: {
        height: (props) => props?.windowHeight - 325,
        overflow: "overlay"
    },
    priceDetailsBody: {
        height: (props) => props?.windowHeight - 325,
        overflow: "overlay",
        padding: "8px"
    },
    priceTotal: {
        backgroundColor: "#E4E8EE",
        borderRadius: "4px",
        padding: "8px"
    },
    unitListContainer: {
        backgroundColor: "rgba(245, 247, 250, 0.9)"
    },
    unitList: {
        height: (props) => props?.windowHeight - 186,
        overflow: "overlay"
    },
    unitImage: {
        height: "100px",
        width: "100%",
        borderRadius: "4px"
    },
    pricingDetailsDiv: {
        backgroundColor: "#F2F4F7",
        borderRadius: theme.palette.borderRadius,
        padding: "16px"
    },
    box: {
        display: "flex",
        padding: "16px",
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        // boxShadow: "0px 8px 24px #0717411F",
        alignItems: "center"
    },
    approved_box: {
        display: "flex",
        padding: "16px",
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        // boxShadow: "0px 8px 24px #0717411F",
        alignItems: "start",
        marginBottom: "12px",
    },
    boxWithOutFlex: {
        padding: "16px",
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        // boxShadow: "0px 8px 24px #0717411F"

    },
    boxWithOutBorder: {
        display: "flex",
        borderRadius: theme.palette.borderRadius,
    },
    italicText: {
        fontSize:"0.75rem",
        // fontStyle: "italic",
        fontFamily: SemiBold,
        color: theme.typography.color.secondary
    },
    semiBoldText: {
        fontSize:"0.75rem",
        color: theme.typography.color.secondary,
        fontFamily: `${SemiBold}`

    },
    regularText: {
        fontSize:"0.75rem",
        color: theme.typography.color.secondary,
        fontFamily: `${Regular}`
    },
    conform: {
        fontSize:"0.75rem",
        color: "#78B1FE",
        fontFamily: `${Bold}`,
        backgroundColor: "#F1F7FF",
        borderRadius: theme.palette.borderRadius,
        padding: "4px"
    },
    decline: {
        fontSize:"0.75rem",
        color: "#FF4B4B",
        fontFamily: `${Bold}`,
        backgroundColor: "#FFECEC",
        borderRadius: theme.palette.borderRadius,
        padding: "4px"

    },
    inProgress: {
        fontSize:"0.75rem",
        color: "#FF9340",
        fontFamily: `${Bold}`,
        backgroundColor: "#FFF4EB",
        borderRadius: theme.palette.borderRadius,
        padding: "4px"

    },
    heading: {
        fontSize:"0.75rem",
        fontFamily: `${Bold}`,
        color: theme.typography.color.tertiary,
        textTransform: "capitalize"
    },
    heading2: {
        fontSize:"0.75rem",
        fontFamily: `${Bold}`,
        color: theme.typography.color.tertiary,
    },
    boxFlex: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    typeTag: {
        padding: "2px 4px",
        backgroundColor: "#5078E1",
        color: "white",
        fontFamily: `${Bold}`,
        borderRadius: "4px",
        fontSize:"0.75rem",
        marginInlineStart: "8px"
    },
    renewal_type: {
        fontSize:"0.75rem",
        color: "#1C1C1C",
        fontFamily: `${Bold}`,
        backgroundColor: "#F2F4F7",
        borderRadius: theme.palette.borderRadius,
        padding: "4px"
    },
    viewDialogText9: {
        fontFamily: SemiBold,
        fontSize:"0.75rem",
        color: "#98A0AC"
    },
    viewDialogText10: {
        fontFamily: SemiBold,
        fontSize:"0.875rem",
        color: "#091B29"
    },
    addNewDialogCustomSwitchContent2: {
        display: "flex",
        alignItems: "center",
        direction: "ltr",
        cursor: "pointer",
    },
    switchContainerOn: {
        position: "relative",
        height: "20px",
        width: "36px",
        borderRadius: "20px",
        backgroundColor: "#EEF9EE"
    },
    switchToggleOn: {
        position: "absolute",
        right: "0px",
        height: "20px",
        width: "20px",
        borderRadius: "20px",
        border: "2px solid white",
        backgroundColor: "#5AC782"
    },
    switchContainerOff: {
        position: "relative",
        height: "20px",
        width: "36px",
        borderRadius: "20px",
        backgroundColor: "#E4E8EE"
    },
    switchToggleOff: {
        height: "20px",
        width: "20px",
        borderRadius: "20px",
        border: "2px solid #E4E8EE",
        backgroundColor: "#98A0AC"
    },
    view_more_less_div: {
        padding: "12px",
        border: "1px solid #E4E8EE",
        cursor: "pointer",
        borderRadius: "0px 0px 4px 4px !important",
        borderTop: "0px !important"
    },
    view_more_less: {
        fontFamily: Bold,
        fontSize: "0.75rem",
        color: "#5078E1",
        cursor: "pointer",
        textAlign: "center",
        textTransform: "capitalize",
    }
}));